export const transformSupportedRemsIdsForSubmit = (value: string | string[]) =>
  Array.isArray(value) ? value : value ? [value] : [];
